var _circle, _circle2, _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIndividuals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    fill: "#E2F9FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 16,
    r: 5,
    stroke: "#21BFE7",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.572 33h-8.518c.182-1.75.824-3.643 1.802-5.265.974-1.615 2.213-2.852 3.542-3.465L21.572 33z",
    stroke: "#21BFE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22 24h4l-2 8-2-8z",
    fill: "#21BFE7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.428 33h8.518c-.182-1.75-.824-3.643-1.802-5.265-.974-1.615-2.213-2.852-3.542-3.465L26.428 33z",
    stroke: "#21BFE7",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMjQiIGZpbGw9IiNFMkY5RkYiLz4KPGNpcmNsZSBjeD0iMjQiIGN5PSIxNiIgcj0iNSIgc3Ryb2tlPSIjMjFCRkU3IiBzdHJva2Utd2lkdGg9IjIiLz4KPHBhdGggZD0iTTIxLjU3MjMgMzNIMTMuMDUzN0MxMy4yMzY0IDMxLjI1IDEzLjg3OCAyOS4zNTY5IDE0Ljg1NjMgMjcuNzM0NkMxNS44MzAxIDI2LjExOTggMTcuMDY4NyAyNC44ODI1IDE4LjM5NzggMjQuMjcwMkwyMS41NzIzIDMzWiIgc3Ryb2tlPSIjMjFCRkU3IiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIvPgo8cGF0aCBkPSJNMjIgMjRIMjZMMjQgMzJMMjIgMjRaIiBmaWxsPSIjMjFCRkU3Ii8+CjxwYXRoIGQ9Ik0yNi40Mjc3IDMzSDM0Ljk0NjNDMzQuNzYzNiAzMS4yNSAzNC4xMjIgMjkuMzU2OSAzMy4xNDM3IDI3LjczNDZDMzIuMTY5OSAyNi4xMTk4IDMwLjkzMTMgMjQuODgyNSAyOS42MDIyIDI0LjI3MDJMMjYuNDI3NyAzM1oiIHN0cm9rZT0iIzIxQkZFNyIgc3Ryb2tlLXdpZHRoPSIyIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz4KPC9zdmc+Cg==";
export { SvgIndividuals as ReactComponent };